<ion-avatar class="avatar--{{ size }}">
    <div class="avatar__default avatar--{{ size }}" *ngIf="!img">
        <span class="avatar__letters avatar__letters--{{ size }}">{{ letters }}</span>
    </div>

    <img class="avatar__image avatar--{{ size }}"
         *ngIf="img"
         src="{{ img }}"
         alt="User Avatar" />
</ion-avatar>
